import styled, { css, keyframes } from 'styled-components';
import { zoomIn } from 'react-animations';
import { media } from '../../styles/theme';

export type VarianteBotao = 'primario' | 'secundario' | 'perigo' | 'fantasma';
export type TamanhoBotao = 'md' | 'sm';

interface ButtonProps {
  $animated?: boolean;
  $variante: VarianteBotao;
  $tamanho: TamanhoBotao;
  $larguraTotal?: boolean;
  $soIcone?: boolean;
}

const animationType = keyframes`${zoomIn}`;
const girar = keyframes`to { transform: rotate(360deg); }`;

const variantes = {
  primario: css`
    background-color: ${({ theme }) => theme.cores.primary};
    border-color: ${({ theme }) => theme.cores.primary};
    color: ${({ theme }) => theme.cores.inkInverse};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.cores.primaryHover};
    }
  `,
  secundario: css`
    background-color: ${({ theme }) => theme.cores.card};
    border-color: ${({ theme }) => theme.cores.border};
    color: ${({ theme }) => theme.cores.primary};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.cores.surface};
      border-color: ${({ theme }) => theme.cores.borderStrong};
    }
  `,
  perigo: css`
    background-color: ${({ theme }) => theme.cores.card};
    border-color: ${({ theme }) => theme.cores.border};
    color: ${({ theme }) => theme.cores.critical};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.cores.criticalSoft};
      border-color: ${({ theme }) => theme.cores.critical};
    }
  `,
  fantasma: css`
    background-color: transparent;
    border-color: transparent;
    color: inherit;

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.cores.surfaceHover};
    }
  `,
};

export const CustomButtom = styled.button<ButtonProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.sm};
  flex-shrink: 0;
  height: ${({ theme, $tamanho }) => ($tamanho === 'sm' ? theme.alturaControle.sm : theme.alturaControle.md)};
  min-width: ${({ theme, $tamanho }) => ($tamanho === 'sm' ? theme.alturaControle.sm : theme.alturaControle.md)};
  width: ${({ $larguraTotal }) => ($larguraTotal ? '100%' : 'auto')};
  padding: 0 ${({ theme, $tamanho, $soIcone }) => ($soIcone ? '0' : $tamanho === 'sm' ? theme.espaco.md : theme.espaco.lg)};
  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.raio.md};
  font-size: ${({ theme, $tamanho }) => ($tamanho === 'sm' ? theme.fonte.small : theme.fonte.body)};
  font-weight: 600;
  white-space: nowrap;
  user-select: none;
  transition: background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
  animation: 0.5s ${({ $animated }) => ($animated ? animationType : 'none')};

  ${({ $variante }) => variantes[$variante]}

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.5;
  }

  .girando {
    animation: ${girar} 0.8s linear infinite;
  }

  ${media.mobile} {
    height: ${({ theme, $tamanho }) => ($tamanho === 'sm' ? theme.alturaControle.md : theme.alturaControle.mobile)};
    min-width: ${({ theme, $tamanho }) => ($tamanho === 'sm' ? theme.alturaControle.md : theme.alturaControle.mobile)};
  }
`;
